import { render, staticRenderFns } from "./ReferralsIndexControls.vue?vue&type=template&id=120e9cdd"
import script from "./ReferralsIndexControls.vue?vue&type=script&lang=js"
export * from "./ReferralsIndexControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports